import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import {
  SPACE_META_PILL_FONT_SIZE,
  SPACE_META_PILL_HEIGHT_PX,
  SPACE_META_PILL_LETTER_SPACING,
  SPACE_META_PILL_LINE_HEIGHT,
  SPACE_META_PILL_PADDING,
  SPACE_META_PILL_RADIUS,
} from './spaceWidgetConstants';
import { HOME_WIDGET_FONT_FAMILY } from '../homeWidgetTypography';

type SpaceMetaPillProps = {
  label: string;
  backgroundColor: string;
  textColor: string;
};

const SpaceMetaPill = ({
  label,
  backgroundColor,
  textColor,
}: SpaceMetaPillProps) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: `${SPACE_META_PILL_HEIGHT_PX}px`,
      minHeight: `${SPACE_META_PILL_HEIGHT_PX}px`,
      p: SPACE_META_PILL_PADDING,
      borderRadius: SPACE_META_PILL_RADIUS,
      bgcolor: backgroundColor,
      color: textColor,
      fontFamily: HOME_WIDGET_FONT_FAMILY,
      fontSize: SPACE_META_PILL_FONT_SIZE,
      lineHeight: SPACE_META_PILL_LINE_HEIGHT,
      letterSpacing: SPACE_META_PILL_LETTER_SPACING,
      fontWeight: 400,
      whiteSpace: 'nowrap',
      flexShrink: 0,
      boxSizing: 'border-box',
    }}
  >
    {label}
  </Box>
);

export default SpaceMetaPill;
